import { observer } from "mobx-react";
import strings from '../../localization';
import ColorPicker from '../ColorPicker';
import { SHAPES } from "../../helpers/statics";
import './index.css';
import { DomPurifyHtml } from "../DomPurifyHtml";

const ShapeTool = ({ tool, index, selected, isColorPickerOpen }) => {
  const toolIcon = SHAPES.find(shape => shape.key === tool.key)?.icon;
  const name = SHAPES.find(shape => shape.key === tool.key)?.name;

  return (
    <button className={`shape-tool ${selected ? 'shape-tool-active' : ''}`} key={index}
      onClick={() => tool.action()}>
      <div className={`shape-tool-icon`}>
        <DomPurifyHtml
          className="shape-tool-icon-svg"
          html={toolIcon}
        />
      </div>
      <span className="shape-tool-name">{strings[name]}</span>
      {tool.key === 'color' && <ColorPicker isColorPickerOpen={isColorPickerOpen} />}
    </button>
  )
}

export default observer(ShapeTool);